import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TopicIcon from '../elements/topic_icon';
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";

class Topics extends Component {
    icons = require.context('../../images/icons/icon_svgs', true);
    topic_data = [
        {"name":"Wholistic Caring",
        "description":"Caring for people is comprised of understanding core and personal needs and providing comprehensive support and continued learning.",
        "icon":"icon_care.svg"
        },
        {"name":"Schedules & Routines",
        "description":"Scheduled routines provide planning and reminders to help define activity and align behavior to meet agendas.",
        "icon":"icon_calandar.svg"
        },
        {"name":"Collaborative Innovation",
        "description":"Working together to achieve prioritized overlapping goals is essential to orchestrating people and resources to achieve our best possibilities.",
        "icon":"icon_collaboration_innovation.svg"
        },
        {"name":"DNA & Genetics",
        "description":"Genetic processing crates an avenue for receiving bio samples and converting that to data for analysis and benefit.",
        "icon":"icon_dna.svg"
        },
        {"name":"Genetic Analyis",
        "description":"Analytics of genetic data is crucial for understanding the biological coding that impacts people’s body and life aspects.",
        "icon":"icon_dna_analysis.svg"
        },
        {"name":"Medical Experts",
        "description":"Medical practitioners work to share and inform our solution design and oversight of customer information and new systems.",
        "icon":"icon_doctor.svg"
        },
        {"name":"Personalized Fomulations",
        "description":"Personalized formulations are based on individual bio and lifestyle data catering variety of products and services to specific customer needs.",
        "icon":"icon_formulations.svg"
        },
        {"name":"AI Brain",
        "description":"Machine Learning and Artificial intelligence systems are able to consume vast and diverse data to process gaining insights and understanding predictive and classification factors delivering new intelligence and supporting decision process.",
        "icon":"icon_ai_brain.svg"
        },
        {"name":"Intelligence Network",
        "description":"Intelligence networks allow us to explore and integrate diverse information and data sources continually expanding our knowledge base and creating actionable analytics and insights.",
        "icon":"icon_brain_network.svg"
        },
        {"name":"Hybrid Human AI Experts",
        "description":"Through collaboration of multidisciplinary teams and AI agents, we work to improve expertise and cross validate to ensure we are at the cutting edge of solution delivery with informed choices.",
        "icon":"icon_hybrid_brain_ai.svg"
        },
        {"name":"Nutrition",
        "description":"Nutrition is fundamental to healthy life and bodily function, mood, and impact us each day and over the long term.",
        "icon":"icon_nutrition.svg"
        },       
        {"name":"Skin Care",
        "description":"Skin care is important for overall wellbeing, and feeling good, as well as avoiding potential ailments and living a long life.",
        "icon":"icon_lotion.svg"
        },
        {"name":"Meditation",
        "description":"Meditation and mindfulness are timeless activities across cultures which make a direct impact on our mental health, daily disposition and choices, and long term health impacts.",
        "icon":"icon_mindfullness.svg"
        },
        {"name":"Caring Touch",
        "description":"Humans are social beings requiring care and nurturing interaction to maintain a healthy sense of self and community.",
        "icon":"icon_massage.svg"
        },
        {"name":"New Ideas",
        "description":"Life is a changing landscape and evolving new ideas and being open to change is crucial for adapting and innovating as we grow and the world evolves.",
        "icon":"icon_mental_idea.svg"
        },
        {"name":"Integrated Intelligence",
        "description":"We orchestrate diverse intelligence and synthesize traditional separated fields and topics to bring together new wholistic operational paradigms and actionable knowledgebases.",
        "icon":"icon_mental_net.svg"
        },
        {"name":"Pro Team",
        "description":"We have a professional community of diverse individuals who help create a rounded picture and capability for us to pioneer, design, and develop solutions, and deliver services to the health space.",
        "icon":"icon_team.svg"
        },
        {"name":"Global Community",
        "description":"Our philosophy and vison encompasses a global community and we work to provide solutions that can scale and account for the diversity of challenges around the world.",
        "icon":"icon_world_experts.svg"
        },       
    ];

    items = this.topic_data.map(item => {
        return <TopicIcon
            icon={this.icons(`./${item.icon}`)}
            name={item.name}
            desc={item.description}
            />;
   });

  render() {
    return (
        <div className="topics">
            <ul className="flex-grid-thirds">
                {this.items}
            </ul>
        </div>
    );
  }
}

export default Topics;